import React from 'react';
import { notification, Tooltip } from 'antd';
import { CopyOutlinedIcon } from 'assets/icons';

const CopyToClipboardButton = ({ content }) => {
  const copyContent = async (event) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(JSON.stringify(content, null, 2));
      notification.success({ message: 'Copied', placement: 'bottomRight' });
    } catch (error) {
      console.error('Failed to copy log details:', error);
    }
  };

  return (
    <Tooltip title='Copy'>
      <button type='button' aria-label='Copy log details' onClick={copyContent} style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer' }}>
        <CopyOutlinedIcon />
      </button>
    </Tooltip>
  );
};

export default CopyToClipboardButton;
